import React from 'react'

export default function PlusIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16 9C16.5523 9 17 9.44772 17 10V22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22V10C15 9.44772 15.4477 9 16 9Z" fill="#453CFB"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M9 16C9 15.4477 9.44772 15 10 15L22 15C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17H10C9.44772 17 9 16.5523 9 16Z" fill="#453CFB"/>
        </svg>
    )
}
